/* ============================================================
   FunkyFood — new-flow.js (Iteration 5)
   Self-contained, native JS (no jQuery).
   Modules: site-header, postcode 2090↔2091, counters, options,
   drawer (Veg 2-tab / Meat 1-tab), loading overlay, size grid,
   deliver row, exclusions fold + chip sync, swap mini-modal.
   ============================================================ */
(function () {
  "use strict";

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- 1. Site header (copied from project script.js) ---------- */
  // slide helpers (verbatim from assets/script.js lines 704-789)
  function stopSlide(element) {
    if (element._slideTimer) {
      clearTimeout(element._slideTimer);
      element._slideTimer = null;
    }
    element._isAnimating = false;
    var cs = window.getComputedStyle(element);
    element.style.transition = "";
    element.style.height = element.offsetHeight + "px";
    element.style.paddingTop = parseFloat(cs.paddingTop) + "px";
    element.style.paddingBottom = parseFloat(cs.paddingBottom) + "px";
    element.style.overflow = "hidden";
  }
  function slideDown(element, duration) {
    duration = duration || 300;
    stopSlide(element);
    element._isAnimating = true;
    element.style.display = "block";
    var style = window.getComputedStyle(element);
    var targetHeight = element.scrollHeight;
    var targetPT = parseFloat(style.paddingTop);
    var targetPB = parseFloat(style.paddingBottom);
    element.style.transition = "height " + duration + "ms ease, padding " + duration + "ms ease";
    requestAnimationFrame(function () {
      element.style.height = targetHeight + "px";
      element.style.paddingTop = targetPT + "px";
      element.style.paddingBottom = targetPB + "px";
    });
    element._slideTimer = setTimeout(function () {
      element.style.removeProperty("height");
      element.style.removeProperty("padding-top");
      element.style.removeProperty("padding-bottom");
      element.style.removeProperty("transition");
      element.style.removeProperty("overflow");
      element._slideTimer = null;
      element._isAnimating = false;
    }, duration);
  }
  function slideUp(element, duration) {
    duration = duration || 300;
    stopSlide(element);
    element._isAnimating = true;
    var style = window.getComputedStyle(element);
    element.style.height = element.offsetHeight + "px";
    element.style.paddingTop = parseFloat(style.paddingTop) + "px";
    element.style.paddingBottom = parseFloat(style.paddingBottom) + "px";
    element.style.transition = "height " + duration + "ms ease, padding " + duration + "ms ease";
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        element.style.height = "0px";
        element.style.paddingTop = "0px";
        element.style.paddingBottom = "0px";
      });
    });
    element._slideTimer = setTimeout(function () {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("padding-top");
      element.style.removeProperty("padding-bottom");
      element.style.removeProperty("transition");
      element.style.removeProperty("overflow");
      element._slideTimer = null;
      element._isAnimating = false;
    }, duration);
  }
  // handleToggle (verbatim from assets/script.js lines 974-1032)
  function handleToggle(item, options) {
    options = options || {};
    var submenuSelector = options.submenuSelector || ".sub-menu";
    var activeClass = options.activeClass || "active";
    var ignoreSelector = options.ignoreSelector || null;
    var scrollWhenOpen = options.scrollWhenOpen !== false;
    return function (e) {
      if (ignoreSelector && e.target.closest(ignoreSelector)) return;
      e.stopPropagation();
      var subs = Array.prototype.slice.call(item.querySelectorAll(submenuSelector));
      if (subs.some(function (s) { return s._isAnimating; })) return;
      var parentList = item.parentNode;
      var siblings = Array.prototype.slice.call(parentList.children).filter(function (c) { return c !== item; });
      siblings.forEach(function (sib) {
        sib.classList.remove(activeClass);
        sib.querySelectorAll(submenuSelector).forEach(function (sm) {
          stopSlide(sm); slideUp(sm, 300);
        });
      });
      var willOpen = !item.classList.contains(activeClass);
      item.classList.toggle(activeClass);
      item.querySelectorAll(submenuSelector).forEach(function (sm) {
        stopSlide(sm);
        if (willOpen) {
          slideDown(sm, 300);
          var kids = Array.prototype.slice.call(parentList.children);
          if (scrollWhenOpen && kids[kids.length - 1] === item) {
            setTimeout(function () {
              item.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 320);
          }
        } else {
          slideUp(sm, 300);
        }
      });
    };
  }

  function initSiteHeader() {
    // On normal pages (theme.liquid) the real site header is wired by
    // script.min.js (burger/menu/accordion) and header.liquid (marquee inline).
    // new-flow.js is now loaded site-wide, so binding here would DOUBLE-bind the
    // burger → two toggles per click → menu never opens. ff-flow layout pages
    // have no site header at all. So skip this whole block whenever the site
    // script is present; it is always redundant.
    if (document.querySelector('script[src*="script.min.js"], script[src*="script.js"]')) return;

    // Burger toggle (port of script.js lines 1043-1068)
    $$(".header-burger").forEach(function (burger) {
      burger.addEventListener("click", function () {
        var mobileMenu = $(".header-mobile-menu");
        if (!mobileMenu) return;
        mobileMenu.classList.toggle("is-active");
        burger.classList.toggle("active");
        $$("html, body").forEach(function (el) {
          el.classList.toggle("overflow-hidden--menu");
        });
      });
    });

    var mobileMenu = $(".header-mobile-menu");
    if (mobileMenu) {
      // Inject close (X) icon into the drawer (same as project)
      var closeIcon = document.createElement("div");
      closeIcon.className = "icon-close";
      closeIcon.innerHTML =
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M10.2452 0.368548L6.26771 4.34602L2.20822 0.286539C1.83456 -0.0871242 1.23484 -0.0932434 0.868731 0.272871C0.502617 0.638985 0.508736 1.2387 0.882399 1.61236L4.94188 5.67185L0.964409 9.64933C0.598294 10.0154 0.604414 10.6152 0.978077 10.9888C1.35174 11.3625 1.95146 11.3686 2.31757 11.0025L6.29505 7.02501L10.3545 11.0845C10.7282 11.4582 11.3279 11.4643 11.694 11.0982C12.0601 10.7321 12.054 10.1323 11.6804 9.75867L7.62087 5.69919L11.5983 1.72171C11.9645 1.3556 11.9583 0.75588 11.5847 0.382217C11.211 0.00855406 10.6113 0.002434 10.2452 0.368548Z" fill="#656565"/>' +
        '</svg>';
      mobileMenu.appendChild(closeIcon);
      closeIcon.addEventListener("click", function () {
        mobileMenu.classList.remove("is-active");
        $$("html, body").forEach(function (el) { el.classList.remove("overflow-hidden--menu"); });
        var b = $(".header-burger"); if (b) b.classList.remove("active");
      });
    }

    // Accordion lists inside mobile drawer (port of script.js lines 1081-1108)
    document.addEventListener("click", function (e) {
      var title = e.target.closest(".accordion-lists .list");
      if (!title) return;
      handleToggle(title, {
        submenuSelector: ".list-drop",
        ignoreSelector: ".list-drop",
        scrollWhenOpen: false
      })(e);
    });

    // Click outside the drawer closes it (port of script.js lines 1777-1793)
    document.addEventListener("click", function (e) {
      var burger = $(".header-burger");
      var mm = $(".header-mobile-menu");
      if (!mm || !mm.classList.contains("is-active")) return;
      var inner = mm.querySelector(".menu-inner");
      var insideMenu = (inner && inner.contains(e.target)) || e.target.closest(".menu-inner");
      var onBurger = (burger && burger.contains(e.target)) || e.target.closest(".header-burger");
      if (!insideMenu && !onBurger) {
        mm.classList.remove("is-active");
        if (burger) burger.classList.remove("active");
        $$("html, body").forEach(function (el) { el.classList.remove("overflow-hidden--menu"); });
      }
    });

    // Announcement-bar marquee (port of inline IIFE in sections/header.liquid lines 126-185)
    var bar = $(".announcement-bar");
    if (bar && !bar.querySelector(".marquee-track")) {
      var p = null;
      var allPs = $$("p", bar);
      for (var k = 0; k < allPs.length; k++) {
        if (allPs[k].textContent.trim()) { p = allPs[k]; break; }
      }
      if (p) {
        for (var j = 0; j < allPs.length; j++) {
          if (allPs[j] !== p) allPs[j].style.display = "none";
        }
        var content = p.innerHTML;
        var track = document.createElement("span");
        track.className = "marquee-track";

        // Measure a single item's width to decide how many copies are needed
        var measure = document.createElement("span");
        measure.className = "marquee-item";
        measure.innerHTML = content;
        measure.style.visibility = "hidden";
        measure.style.position = "absolute";
        bar.appendChild(measure);
        var itemW = measure.offsetWidth;
        bar.removeChild(measure);

        function getNeededCopies() {
          var vw = window.innerWidth;
          var raw = Math.max(4, Math.ceil((vw * 2) / itemW) + 2);
          return raw % 2 === 0 ? raw : raw + 1;
        }

        var copyCount = getNeededCopies();
        for (var i = 0; i < copyCount; i++) {
          var item = document.createElement("span");
          item.className = "marquee-item";
          item.innerHTML = content;
          track.appendChild(item);
        }
        p.innerHTML = "";
        p.appendChild(track);

        function updateMarquee() {
          var needed = getNeededCopies();
          while (copyCount < needed) {
            var more = document.createElement("span");
            more.className = "marquee-item";
            more.innerHTML = content;
            track.appendChild(more);
            copyCount++;
          }
          var first = track.querySelector(".marquee-item");
          if (!first) return;
          var w = first.offsetWidth;
          var halfTrack = (copyCount * w) / 2;
          var duration = halfTrack / 60; // ~60 px/s
          track.style.setProperty("--marquee-duration", duration + "s");
        }
        updateMarquee();
        window.addEventListener("resize", updateMarquee);
      }
    }

    // Sticky header hide-on-scroll-down / reveal-on-scroll-up
    // (port of StickyHeader custom element in sections/header.liquid lines 425-513)
    var header = $(".header");
    if (header) {
      var lastScroll = 0;
      var threshold = 80;
      window.addEventListener("scroll", function () {
        var top = window.pageYOffset || document.documentElement.scrollTop;
        if (top <= threshold) {
          header.classList.remove("sticky", "is-hidden", "is-revealed");
        } else if (top > lastScroll) {
          header.classList.add("sticky", "is-hidden");
          header.classList.remove("is-revealed");
        } else {
          header.classList.add("sticky", "is-revealed");
          header.classList.remove("is-hidden");
        }
        lastScroll = top;
      }, { passive: true });
    }
  }

  /* ---------- 2. Postcode validation (2090) ----------
     Handled entirely by ff-flow-data.js init2090() (real zone lookup +
     invalid-postcode error). The old naive 4-digit check here was removed
     because it false-validated unserviced postcodes and fought init2090. */

  /* ---------- 3. Counters (2092) ---------- */
  function initCounters() {
    // 2092 household: the bottom Continue button only shows once at least one
    // counter (adults + children combined) is > 0. Other steps have no
    // .ff-counters, so syncContinue() is a no-op there.
    var counters = $(".ff-counters");
    var continueBtn = counters ? $(".ff-actions__inner .ff-btn") : null;
    function syncContinue() {
      if (!counters || !continueBtn) return;
      var total = 0;
      $$(".ff-qty__value", counters).forEach(function (v) {
        total += parseInt((v.tagName === "INPUT" ? v.value : v.textContent) || "0", 10) || 0;
      });
      continueBtn.classList.toggle("is-hidden", total <= 0);
    }
    $$(".ff-qty").forEach(function (qty) {
      var minus = $('[data-action="dec"]', qty);
      var plus  = $('[data-action="inc"]', qty);
      var value = $(".ff-qty__value", qty);
      if (!minus || !plus || !value) return;
      var min = parseInt(qty.getAttribute("data-min") || "0", 10);
      var max = parseInt(qty.getAttribute("data-max") || "10", 10);
      var isInput = value.tagName === "INPUT";
      function read()  { return parseInt((isInput ? value.value : value.textContent) || "0", 10); }
      function write(v) { if (isInput) value.value = String(v); else value.textContent = String(v); }
      function set(v) {
        if (isNaN(v)) v = min;
        v = Math.max(min, Math.min(max, v));
        write(v);
        minus.disabled = v <= min;
        plus.disabled  = v >= max;
        syncContinue();
      }
      set(read());
      minus.addEventListener("click", function () { set(read() - 1); });
      plus.addEventListener("click",  function () { set(read() + 1); });
      if (isInput) {
        // Direct typing: keep digits only (max 2), update button state live,
        // clamp/normalise on blur (empty → min, >max → max).
        value.addEventListener("input", function () {
          var digits = value.value.replace(/[^0-9]/g, "").slice(0, 2);
          if (digits !== value.value) value.value = digits;
          var n = parseInt(digits || "0", 10);
          minus.disabled = n <= min;
          plus.disabled  = n >= max;
          syncContinue();
        });
        value.addEventListener("blur", function () { set(read()); });
        value.addEventListener("keydown", function (e) {
          if (e.key === "Enter") { e.preventDefault(); value.blur(); }
        });
        value.addEventListener("focus", function () { value.select(); });
      }
    });
    syncContinue();
  }

  /* ---------- 4. Option single-select (2093/2094) ---------- */
  function initOptions() {
    $$(".ff-options").forEach(function (group) {
      var opts = $$(".ff-option", group);
      opts.forEach(function (opt) {
        opt.addEventListener("click", function () {
          opts.forEach(function (o) {
            o.classList.remove("is-selected");
            o.setAttribute("aria-checked", "false");
          });
          opt.classList.add("is-selected");
          opt.setAttribute("aria-checked", "true");
        });
      });
    });
  }

  /* ---------- 5. Drawer (Veg 2-tab / Meat 1-tab) ---------- */
  function lockBodyScroll() {
    if (document.body.classList.contains("ff-no-scroll")) return;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) {
      document.documentElement.style.setProperty("--ff-scrollbar-pad", sbw + "px");
      document.documentElement.classList.add("ff-scroll-lock-pad");
    }
    document.body.classList.add("ff-no-scroll");
  }
  function unlockBodyScroll() {
    document.body.classList.remove("ff-no-scroll");
    document.documentElement.classList.remove("ff-scroll-lock-pad");
    document.documentElement.style.removeProperty("--ff-scrollbar-pad");
  }
  function initDrawer() {
    var stack = [];
    function open(id) {
      var drawer = document.getElementById(id);
      if (!drawer) return;
      // ff-flow-data.js can set inline display:none on #drawer-meat (step-4
      // vegetarian / removed-meat state). The edit chip is still clickable, so
      // clear it here — otherwise .is-open (which only flips visibility) can't
      // override inline display:none and the drawer never appears.
      drawer.style.display = "";
      lockBodyScroll();
      // force a reflow so the browser registers the pre-open state
      // before applying .is-open — guarantees the slide-in animation runs.
      void drawer.offsetWidth;
      requestAnimationFrame(function () {
        drawer.classList.add("is-open");
        drawer.setAttribute("aria-hidden", "false");
      });
      stack.push(drawer);
    }
    function close(drawer) {
      if (!drawer) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      // Wipe the size-grid is-active on close so the next open never
      // paints the previous row's selection before syncActiveSizeFromCart
      // finishes. The correct is-active is re-applied on open.
      var grid = drawer.querySelector(".ff-size-grid");
      if (grid) {
        grid.querySelectorAll("[data-size].is-active").forEach(function (el) {
          el.classList.remove("is-active");
        });
      }
      stack = stack.filter(function (d) { return d !== drawer; });
      if (!stack.length) unlockBodyScroll();
    }

    // Reflect the size that's currently in localCart onto the drawer's
    // .ff-size-grid so the box the customer already has is visibly
    // is-active when the drawer opens. Runs on drawer open — not on init
    // — so it always matches the live cart, not the state at page load.
    function syncActiveSizeFromCart(drawerId, sourceBtn) {
      var drawer = document.getElementById(drawerId);
      if (!drawer) return;
      var kind = drawerId === "drawer-meat" ? "meat" : "veg";
      var sizeMap = (window.__ffBoxData && window.__ffBoxData[kind]) || {};
      var vidToSize = {};
      Object.keys(sizeMap).forEach(function (k) {
        var entry = sizeMap[k];
        var v = entry && (entry.variantId || entry.id);
        if (v) vidToSize[String(v)] = k;
      });
      var lc;
      try { lc = JSON.parse(localStorage.getItem("localCart") || "[]"); }
      catch (e) { lc = []; }
      var size = null;
      // Derive the row's variantId directly from the clicked button so
      // multiple cart rows of the same kind each open the drawer at THEIR
      // row's size. We can't rely on window.__ffMeatEditContext because
      // cart-modal-slider's capture-phase handler on document.body runs
      // AFTER this document-level capture handler, so ctx isn't populated
      // yet at this point.
      if (kind === "meat" && sourceBtn && sourceBtn.closest) {
        var row = sourceBtn.closest("tr.cart-item");
        if (row && row.id) {
          var m = row.id.match(/^CartItem-(\d+)-/);
          if (m && vidToSize[String(m[1])]) size = vidToSize[String(m[1])];
        }
      }
      // Step-flow persisted size takes priority — on new-step-4-order
      // the customer's chosen size is written to ffNewFlow.boxSizes on
      // every card-chip click and is the most recent explicit signal.
      // Checked BEFORE localCart because localCart can carry a stale
      // variantId from an earlier session or a shared-variant rescue
      // box, which would otherwise pin the drawer to the wrong size.
      if (!size) {
        try {
          var flowSizes = JSON.parse(localStorage.getItem("ffNewFlow.boxSizes") || "null");
          var flowSize = flowSizes && flowSizes[kind];
          if (flowSize && sizeMap[flowSize]) size = flowSize;
        } catch (e) {}
      }
      if (!size) {
        for (var i = 0; i < (lc || []).length; i++) {
          var it = lc[i];
          var vid = it && (it.variantId || it.id);
          if (vid && vidToSize[String(vid)]) { size = vidToSize[String(vid)]; break; }
        }
      }
      // Fall back to the first available size (Small → Medium → XSmall →
      // Big) so the drawer never opens empty even when the customer has
      // no product of this kind in cart yet.
      if (!size) {
        var order = ["S", "M", "X", "B"];
        for (var j = 0; j < order.length; j++) {
          if (sizeMap[order[j]]) { size = order[j]; break; }
        }
      }
      if (!size) return;
      var grid = drawer.querySelector(".ff-size-grid");
      if (grid) {
        grid.querySelectorAll("[data-size]").forEach(function (el) {
          el.classList.toggle("is-active", el.getAttribute("data-size") === size);
        });
      }
      // Populate drawer head + What's included list. applyDrawerHead is
      // the same closure ff-flow-data.js uses when a size chip is clicked
      // (bindDrawerSize) — exposed as window.__ffApplyDrawerHead so we
      // can render on drawer open without the customer having to click a
      // chip first. Without this the meat drawer opens with an empty
      // incl list on shop-now (there's no meat card element to init
      // from).
      if (typeof window.__ffApplyDrawerHead === "function") {
        try { window.__ffApplyDrawerHead(kind, size); } catch (e) {}
      }
    }

    // Delegated — the cart-modal renders pencils dynamically, so static
    // binding misses them. Listen during the capture phase so a child
    // onclick='event.stopPropagation()' (used by the cart pencil to
    // protect against the row-click handler) doesn't kill us.
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-drawer-open]");
      if (!btn) return;
      var targetId = btn.getAttribute("data-drawer-open");
      // Apply size + head content BEFORE the drawer opens so it never
      // flashes the previous row's state during the open transition.
      syncActiveSizeFromCart(targetId, btn);
      open(targetId);
    }, true);
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (t.matches && (t.matches("[data-drawer-close]") || t.closest("[data-drawer-close]"))) {
        var d1 = t.closest(".ff-drawer"); if (d1) close(d1);
      }
    });
    // Clicking the empty area (anything inside an open .ff-drawer but outside
    // its sliding panel) closes it — covers gaps the overlay element doesn't
    // physically cover, where [data-drawer-close] alone wouldn't fire.
    document.addEventListener("click", function (e) {
      var d = e.target.closest && e.target.closest(".ff-drawer.is-open");
      if (!d) return;
      var panel = d.querySelector(".ff-drawer__panel");
      if (panel && !panel.contains(e.target)) close(d);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && stack.length) close(stack[stack.length - 1]);
    });

    // Drawer tabs
    $$(".ff-drawer__tab").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var drawer = tab.closest(".ff-drawer"); if (!drawer) return;
        var target = tab.getAttribute("data-tab");
        $$(".ff-drawer__tab", drawer).forEach(function (t) { t.classList.remove("is-active"); });
        tab.classList.add("is-active");
        $$(".ff-drawer__panel-pane", drawer).forEach(function (pane) {
          pane.classList.toggle("is-active", pane.getAttribute("data-pane") === target);
        });
      });
    });
  }

  /* ---------- 6. Loading overlay (3.5) ---------- */
  function initLoadingOverlay() {
    var overlay = $(".ff-loading-overlay");
    if (!overlay) return;
    function show() { overlay.classList.add("is-active"); document.body.classList.add("ff-no-scroll"); }
    function hide() { overlay.classList.remove("is-active"); document.body.classList.remove("ff-no-scroll"); }
    function syncFromHash() { if (window.location.hash === "#loading") show(); else hide(); }
    // On (re)load — including a browser back that fully re-renders the page — a
    // leftover "#loading" hash (set when navigating away via a [data-show-loading]
    // button) must NOT re-open the overlay. Strip it and start hidden; the overlay
    // only opens from a genuine click handled below.
    if (window.location.hash === "#loading") {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }
    hide();
    window.addEventListener("hashchange", syncFromHash);
    $$("[data-show-loading]").forEach(function (btn) {
      btn.addEventListener("click", function () { window.location.hash = "loading"; });
    });
    overlay.addEventListener("click", function () {
      if (window.location.hash === "#loading") {
        history.replaceState(null, "", window.location.pathname + window.location.search);
      }
      hide();
    });
  }

  /* ---------- 7. Size tags (box card on 2095) ---------- */
  function initSizeTags() {
    $$(".ff-box-card__sizes").forEach(function (group) {
      var tags = $$(".ff-size-tag", group);
      tags.forEach(function (tag) {
        tag.addEventListener("click", function () {
          tags.forEach(function (t) { t.classList.remove("is-active"); });
          tag.classList.add("is-active");
        });
      });
    });
  }

  /* ---------- 8. Deliver row (meat box card) ---------- */
  function initDeliverRow() {
    $$(".ff-box-card__deliver-row").forEach(function (group) {
      var tags = $$(".ff-box-card__deliver-tag", group);
      tags.forEach(function (tag) {
        tag.addEventListener("click", function () {
          tags.forEach(function (t) { t.classList.remove("is-active"); });
          tag.classList.add("is-active");
        });
      });
    });
  }

  /* ---------- 9. Size grid (drawer inner 2x2) ---------- */
  function initSizeGrid() {
    $$(".ff-size-grid").forEach(function (group) {
      var boxes = $$(".ff-size-box", group);
      boxes.forEach(function (b) {
        b.addEventListener("click", function () {
          boxes.forEach(function (x) { x.classList.remove("is-active"); });
          b.classList.add("is-active");
        });
      });
    });
  }

  /* ---------- 10. Exclusions fold + checkbox <-> chips sync ---------- */
  function initExclusions() {
    // Fold toggle (data-excl-toggle is the button; container is [data-excl-fold])
    $$("[data-excl-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var box = btn.closest("[data-excl-fold]");
        if (!box) return;
        var open = box.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", String(open));
      });
    });

    $$("[data-excl-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) { e.preventDefault(); });
    });

    // Search filter over the rendered rows.
    $$("[data-excl-search]").forEach(function (input) {
      var box = input.closest("[data-excl-fold]");
      var list = box && $(".ff-excl-fold-drop", box);
      if (!box || !list) return;

      function apply() {
        var q = input.value.trim().toLowerCase();
        $$(".ff-excl-row", list).forEach(function (row) {
          var nameEl = row.querySelector(".ff-excl-row__name");
          var name = nameEl ? nameEl.textContent.toLowerCase() : "";
          // A class, not [hidden]: .ff-excl-row sets display:flex and outranks the UA rule.
          row.classList.toggle("is-excl-filtered", q !== "" && name.indexOf(q) === -1);
        });
      }

      input.addEventListener("input", function () {
        if (input.value.trim() && !box.classList.contains("is-open")) {
          box.classList.add("is-open");
          var t = $("[data-excl-toggle]", box);
          if (t) t.setAttribute("aria-expanded", "true");
        }
        apply();
      });

      // ff-flow-data.js rebuilds these rows (renderExclusions) well after init, and again on
      // every portal resolve - without this the filter silently drops on the next rebuild.
      new MutationObserver(apply).observe(list, { childList: true });
    });

    // Each Exclusions pane has its own checkbox list + chip row
    $$(".ff-drawer__panel-pane[data-pane='exclusions']").forEach(function (pane) {
      var list  = $(".ff-excl-fold-drop", pane);
      var chips = $("[data-excl-chips]", pane);
      if (!list || !chips) return;

      function renderChips() {
        chips.innerHTML = "";
        $$("input[type='checkbox']", list).forEach(function (cb) {
          if (!cb.checked) return;
          var nameEl = cb.parentElement.querySelector(".ff-excl-row__name");
          var name = nameEl ? nameEl.textContent : "";
          var chip = document.createElement("button");
          chip.type = "button";
          chip.className = "ff-excl-chip";
          chip.innerHTML = name +
            '<span class="ff-excl-chip__close">' +
            '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
            '<path d="M2 2l6 6M8 2L2 8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
            "</svg></span>";
          chip.addEventListener("click", function () {
            cb.checked = false;
            enforceLimit();
            renderChips();
          });
          chips.appendChild(chip);
        });
      }

      // Hard cap of 10 exclusions. Once 10 are checked, every *unchecked* box
      // is disabled (CSS turns its border red + cursor:not-allowed). Runs on
      // every change AND on init so a page that loads with 10 already-checked
      // rows starts in the locked state.
      var MAX_EXCL = 10;
      function enforceLimit() {
        var boxes = $$("input[type='checkbox']", list);
        var checked = 0;
        boxes.forEach(function (cb) { if (cb.checked) checked++; });
        var atLimit = checked >= MAX_EXCL;
        boxes.forEach(function (cb) {
          if (!cb.checked) cb.disabled = atLimit;
        });
      }

      $$("input[type='checkbox']", list).forEach(function (cb) {
        cb.addEventListener("change", function () {
          enforceLimit();
          renderChips();
        });
      });
      enforceLimit();
      renderChips();
    });
  }

  /* ---------- 11. Swap mini-modal (triggered from Veg incl Swap btn) ----------
     Pattern follows the project's swap-product:
       - record current row in `currentSwapItem`
       - write selected name/icon into that row (no qty/price)
       - add `.is-swapped` to the row for persistent yellow ring
       - add `.swap-animation` to the chosen modal row for a 1.5s flash
  */
  function initSwapModal() {
    var modal = $("#swap-modal");
    if (!modal) return;
    var subEl = $("[data-swap-sub]", modal);
    var currentSwapItem = null;

    function open(triggerBtn) {
      var row = triggerBtn && triggerBtn.closest(".ff-incl-item");
      currentSwapItem = row || null;
      if (subEl) {
        var nameEl = row && row.querySelector(".ff-incl-item__name");
        subEl.textContent = nameEl ? nameEl.textContent.trim() : "";
      }
      lockBodyScroll();
      requestAnimationFrame(function () {
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
      });
    }
    function close() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      currentSwapItem = null;
      if (subEl) subEl.textContent = "";
      if (!$(".ff-drawer.is-open")) unlockBodyScroll();
    }

    // Event delegation so swap buttons inserted later (the dynamic
    // veg items list is filled after the weekly-menu fetch resolves)
    // still trigger the modal.
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-swap-open]");
      if (!btn) return;
      e.preventDefault();
      open(btn);
    });
    $$("[data-swap-close]", modal).forEach(function (el) { el.addEventListener("click", close); });
    modal.addEventListener("click", function (e) {
      if (e.target.classList && e.target.classList.contains("ff-swap-modal__overlay")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-open")) close();
    });

    // Delegated row-click — swap options are rendered dynamically from
    // the weekly menu after this init runs.
    modal.addEventListener("click", function (e) {
      var row = e.target.closest && e.target.closest(".ff-swap-modal__row");
      if (!row || !modal.contains(row)) return;
      if (!currentSwapItem) { close(); return; }
      var newName = row.getAttribute("data-swap-name") || "";
      var newIcon = row.getAttribute("data-swap-icon") || "";
      var origName = currentSwapItem.querySelector(".ff-incl-item__name");
      var origImg  = currentSwapItem.querySelector(".ff-incl-item__icon img");
      if (origName && newName) origName.textContent = newName;
      if (origImg && newIcon)  origImg.setAttribute("src", newIcon);
      currentSwapItem.classList.add("is-swapped");

      row.classList.add("swap-animation");
      setTimeout(function () { row.classList.remove("swap-animation"); }, 1500);

      close();
    });
  }

  /* ---------- 12. Box card remove (2095) ---------- */
  function initBoxCardRemove() {
    $$(".ff-box-card__remove").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var card = btn.closest(".ff-box-card");
        if (card) card.remove();
      });
    });
  }

  /* ---------- 13. Cart icon hover-bg flicker fix ----------
     The collection-header cart icon paints a yellow :hover background. Clicking
     it opens the cart drawer, but the pointer stays over the icon during the
     slide-in, so the yellow bg flickers then vanishes as the overlay covers it.
     Suppress the hover bg from click until the pointer actually leaves the icon
     (CSS: .header__icon--cart.ff-no-hover-bg:hover in new-flow.css). */
  function initCartHoverFix() {
    $$(".header__icon--cart").forEach(function (icon) {
      // Suppress the hover bg on pointerdown, NOT click: the icon's inline
      // onclick="showCartModal(true)" is registered first (HTML before this JS),
      // so on click it runs — and blocks the main thread building the cart —
      // BEFORE this listener could add the class, leaving the yellow bg stuck
      // through the jank. pointerdown fires on press, before the click/onclick,
      // so the bg is already suppressed when the heavy work hits.
      icon.addEventListener("pointerdown", function () { icon.classList.add("ff-no-hover-bg"); });
      icon.addEventListener("mouseleave", function () { icon.classList.remove("ff-no-hover-bg"); });
    });
  }

  /* ---------- cart modal: Order Total collapse/expand ----------
     Figma 14229:87028 shows the Order Total row on its own; the
     subtotal / discount / delivery breakdown is revealed on click. */
  function initCartOrderTotal() {
    var trigger = $(".cart-model-bottom .order-total__details");
    var box = $("#order-total-drop-box");
    if (!trigger || !box) return;

    function toggle() {
      var willOpen = box.offsetHeight === 0 || window.getComputedStyle(box).display === "none";
      if (willOpen) slideDown(box, 300);
      else slideUp(box, 300);
      trigger.setAttribute("aria-expanded", String(willOpen));
      trigger.classList.toggle("is-open", willOpen);
    }

    trigger.addEventListener("click", toggle);
    trigger.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      toggle();
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    // Each init is isolated: a throw in one (e.g. a page missing the elements
    // it expects) must not abort the rest. Previously an early failure here
    // (initCartOrderTotal/SiteHeader/Counters/Options) stopped boot() before
    // initDrawer(), so the drawer's [data-drawer-open] delegate never bound
    // and the edit chips did nothing. The failing init is logged so it can be
    // fixed at the source.
    var steps = [
      ["initCartOrderTotal", initCartOrderTotal],
      ["initSiteHeader", initSiteHeader],
      ["initCounters", initCounters],
      ["initOptions", initOptions],
      ["initDrawer", initDrawer],
      ["initLoadingOverlay", initLoadingOverlay],
      ["initSizeTags", initSizeTags],
      ["initDeliverRow", initDeliverRow],
      ["initSizeGrid", initSizeGrid],
      ["initExclusions", initExclusions],
      ["initSwapModal", initSwapModal],
      ["initBoxCardRemove", initBoxCardRemove],
      ["initCartHoverFix", initCartHoverFix],
    ];
    for (var i = 0; i < steps.length; i++) {
      try {
        steps[i][1]();
      } catch (e) {
        if (window.console && console.error) {
          console.error("[new-flow] " + steps[i][0] + " failed:", e);
        }
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
